import { connect } from 'react-redux'
import { createWidget } from 'pages/widgets/form-actions/create/actions'
import Form from 'pages/widgets/form'

const mapDispatch = {
  onSubmit: createWidget
}

export default connect(null, mapDispatch)(Form)



// WEBPACK FOOTER //
// ./src/pages/widgets/mentions/create/container/index.js